import { listFilterDescription } from "./index";
import { Select } from "./Select";
import { CompanyFilters } from "../../../company";
import { UserFilters } from "../../../user/types";
import { StateAction } from "../../../helpers/functions/types";

export const FilterSelect = (
  filterOptions: listFilterDescription<CompanyFilters | UserFilters>,
  activeFilters: string[],
  setFilters: StateAction<any>,
  index: number,
) => {
  const selectedOption =
    filterOptions.find(({ text }) => activeFilters.includes(text))?.text ??
    filterOptions[0].text;

  const relevantFilters = (newOptionValue: string) => {
    return activeFilters.map((filter) =>
      filter === selectedOption ? newOptionValue : filter,
    );
  };
  return (
    <div className="flex min-w-[140px]" key={index}>
      <Select
        activeOption={selectedOption ?? filterOptions[0].text}
        handleSelect={(value: string) => setFilters(relevantFilters(value))}
        options={filterOptions.map(({ text }) => text)}
        customText=""
      ></Select>
    </div>
  );
};
